import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/products/page.tsx");
